import styles from "@components/typography/TextWithHighlight.module.css";
import { escapeRegularExpressionText } from "@utils/stringUtils";

type Props = {
  extract?: boolean;
  match?: string | null;
  text?: string | null;
};

const TextWithHighlight = ({ extract = false, match, text }: Props) => {
  if (!match || !text) return text;

  const extractSubstring = (string: string, searchTerm: string) => {
    // Convert both string and searchTerm to lowercase
    const lowercasedString = string.toLowerCase();
    const lowercasedSearchTerm = searchTerm.toLowerCase();

    // Find the index of the search term in the lowercase string
    const index = lowercasedString.indexOf(lowercasedSearchTerm);

    if (index !== -1) {
      // Determine the starting and ending indices for the substring
      const rangeSize = 25;
      const start = Math.max(0, index - rangeSize);
      const end = Math.min(string.length, index + searchTerm.length + rangeSize);

      // Extract the substring from the original string
      const substring = string.substring(start, end);
      return substring;
    } else {
      return text;
    }
  };

  const regex = new RegExp(`(${escapeRegularExpressionText(match)})`, "gi");
  const parts = extract ? extractSubstring(text, match).split(regex) : text.split(regex);

  return (
    <>
      {parts?.map(part => (
        <span className={part.toLowerCase() === match.toLowerCase() ? styles.highlight : ""} key={part}>
          {part}
        </span>
      ))}
    </>
  );
};

export default TextWithHighlight;
